import utils from './utils';
import appUtils from './app_utils'

require('intersection-observer')

const buildThresholdList = function() {
  let thresholds = [];
  let numSteps = 10;

  for (let i=1.0; i<=numSteps; i++) {
    let ratio = i/numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
}

let svgObserverTargets = [];
const svgObserverOptions = {
 rootMargin: '0px 0px -25% 0px', // '0px'
 threshold: buildThresholdList() // 1
};
const svgObserverCallback = (entries, svgObserver) => {
 entries.forEach(entry => {
   const cssClass = entry.target.getAttribute('data-class-toggle-inout')
   if (entry.isIntersecting) { //  && entry.intersectionRatio === 1
     entry.target.classList.add(cssClass)
   } else {
     entry.target.classList.remove(cssClass)
   }
 });
};

// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/IntersectionObserver
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/observe
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/unobserve
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/disconnect
const svgObserver = new IntersectionObserver(svgObserverCallback, svgObserverOptions);

const getAttributeObject = function(str='') {
  // jquery .data() requires a data-name='{"name": "value"}' pattern, not good for minification
  const dataString = str.replace(/'/g, '"')
  let obj = {}
  try {
    obj = JSON.parse(dataString)
  } catch (e) {
    console.log(e)
  } finally {
    return obj
  }
}

/*
* global svgGoTo function
*/
window.svgGoTo = function(destination, selector = '', urls = []) {
  const index = parseInt(destination, 10)
  if( typeof(index) === 'number' && !isNaN(index) ) {
    if (selector) {
      let $selectorEl = $(selector + ':eq(' + (index - 1) + ')')
      if ($selectorEl.length) {
        if ($selectorEl.is('a') || $selectorEl.is('button')) {
          $selectorEl.click()
        } else {
          appUtils.scrollTo($selectorEl);
        }
      }
    } else if (urls) {
      if (typeof(urls[index - 1])==='string') {
        if(typeof(appUtils.goTo)==='function') {
          appUtils.goTo(urls[index - 1]);
        }
      }
    }
  } else {
    if (destination) {
      let $selectorEl = $(destination)
      if ($selectorEl.length) {
        if ($selectorEl.is('a') || $selectorEl.is('button')) {
          $selectorEl.click()
        } else {
          appUtils.scrollTo($selectorEl);
        }
      }
    }
  }
}

class SvgInline {
  constructor(target, args = { dataAttr: 'svginline', instanceIndex: 0 }) {
    this.target = target

    this.$el = $(this.target)

    this.$window = $(window)

    this.options = Object.assign({}, args, getAttributeObject(this.$el.attr('data-' + args.dataAttr)))

    if (this.options.urls) {
      this.options.urls = this.options.urls.split(',')
    } else {
      this.options.urls = null
    }

    const $img = this.$el;

    const imgID = this.$el.attr('id');

    const imgClass = this.$el.attr('class');

    const imgURL = this.$el.attr('data-src');

    $.get(imgURL, (data) => {
      // Get the SVG tag, ignore the rest
      let $svg = $(data).find('svg');

      if (!$svg.length) {
        return
      }

      // replace acute accent (illustrator option) es svgGoTo(‘1’);
      let svgHtml = $svg.html().replace(/svgGoTo\(‘(.+?)’\)/gi, 'svgGoTo(\'$1\')')

      if(this.options.linkselector) {
        // svgGoToInstance reference
        window['svgGoTo' + this.options.instanceIndex] = (destination) => {
          window.svgGoTo(destination, this.options.linkselector)
        }
      } else if (this.options.urls) {
        // svgGoToInstance reference
        window['svgGoTo' + this.options.instanceIndex] = (destination) => {
          window.svgGoTo(destination, '', this.options.urls)
        }
      }

      if (typeof(window['svgGoTo' + this.options.instanceIndex])==='function') {
        svgHtml = svgHtml.replace(/svgGoTo\('(.+?)'\)/gi, 'svgGoTo' + this.options.instanceIndex + '(\'$1\')')
      }

      $svg.html(svgHtml)

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', $svg.attr('class') + ` ${imgClass} svg-inline`);
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
      if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr(`viewBox 0 0  ${$svg.attr('height')} ${$svg.attr('width')}`);
      }

      if (this.target.getAttribute('data-class-toggle-inout')) {
        $svg = $svg.attr('data-class-toggle-inout', this.target.getAttribute('data-class-toggle-inout'));

        const el = $svg[0]
        svgObserver.observe(el)
        svgObserverTargets.push(el)
      }

      // Replace image with new SVG
      //$img.replaceWith($svg);
      $img.after($svg);

      setTimeout(() => {
        this.$window.trigger('stickySidebar:update');
      }, 20);
    }, 'xml');
  }

  destroy() {
    // remove the svgGoToInstance reference
    delete window['svgGoTo' + this.options.instanceIndex]
  }
}

let init = function() {
  const dataAttr = 'svginline'
  $('[data-svginline]').each(function(index, item) {
    const svgInline = new SvgInline(this, { dataAttr: dataAttr, instanceIndex: index })
    $(this).data('svgInline', svgInline)
  })
}

let destroy = function() {
  // unobserve!
  if (svgObserverTargets.length) {
    svgObserverTargets.forEach(target => svgObserver.unobserve(target));
  }

  $('[data-svginline]').each(function(index, item) {
    const svgInline = $(this).data('svgInline')
    if (svgInline) {
      svgInline.destroy()
    }
  })
}

export default {init, destroy}
